export default '/build/8c147d1f.svg'